import Browser from '@mindful-web/marko-web/browser';
import Shared from '@keller/package-global/browser';

Shared(Browser);

export default Browser;
